/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://nbubx0w7v9.execute-api.us-east-2.amazonaws.com/westin",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://sqmhhtpy45e7vgl6ilir3zwygq.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-qow5j3wgtzhfhbgmfo7kih6izq",
    "aws_cognito_identity_pool_id": "us-east-2:8cdef3a8-101b-4827-b444-537f600edb61",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_8CHW8eljs",
    "aws_user_pools_web_client_id": "240viv2crhhetkn18pc1hfl9v1",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
